module.exports = {
    url: 'http://localhost:3005'
}